/* eslint-disable react/jsx-no-target-blank */
import * as React from 'react'
import classNames from 'classnames'
import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import fetch, { IBaseResponse } from 'lib/decorated-fetch'
import getUrl from 'lib/url'
import { metrics } from 'lib/slardar-utils'

export interface IOuterLink {
  keyword?: string
  url?: string
}

export interface IOuterLinkProps {
  linkList: IOuterLink[]
}

const logger = (uri: string, req?: any) => {
  if (req) {
    req.metrics.emitCounter('seo.outer_link.fail', 1, undefined, {
      uri,
    })
  } else {
    metrics.counter(`seo.outer_link.fail`, {
      uri,
    })
  }
  return []
}

/** 获取外部链接列表 */
export const getOuterLinkList = async (uri: string, req?: any) => {
  if (!req?.isSpider) return []
  try {
    const domain = 'www.dongchedi.com'
    const params = {
      domain_url: `${domain}${uri}`,
      domain,
      link_type: '汽车',
      link_count: 20,
    }
    const json: IBaseResponse<IOuterLink[]> = await fetch(
      getUrl(
        `/motor/pc/common/seo/link_voting/v1/get_link_list?${serializeObject(
          params
        )}`,
        'motor.pc_common.api'
      ),
      { req }
    )
    if (0 !== json?.status) {
      return logger(uri, req)
    }
    return json?.data
  } catch {
    return logger(uri, req)
  }
}

/** 外部链接 */
export default function OuterLink(props: IOuterLinkProps) {
  const { linkList } = props
  if (!linkList.length) return null
  return (
    <div className="tw-border-t-1 tw-pt-12 tw-m-16 tw-text-color-gray-600">
      <span>推荐：</span>
      {linkList.map((link, index) => (
        <a
          className={classNames('tw-px-8', {
            'tw-border-l-1 tw-border-color-gray-600': index !== 0,
          })}
          key={index}
          href={link.url}
          target="_blank"
        >
          {link.keyword}
        </a>
      ))}
    </div>
  )
}
